import Response from './Response'
import ResponseOverview from './overview/Overview'
import ResponseAnalysis from './analysis/Analysis'

export default [
    {
        path: 'response',
        component: Response,

        children: [
            {
                component: ResponseOverview,
        		path: '',
                name: 'response'
        	},
            {
                component: ResponseAnalysis,
        		path: ':id',
                name: 'response-analysis',
                props: true
        	}
        ]
    }
]
